import React from 'react';
import MyNavbar from "../../../components/user/general/mynavbar/MyNavbar";
import Footer from "../../../components/user/general/footer/Footer";
import BlogBanner from '../../../subscreens/users/blogs/blogBanner/BlogBanner';
import BlogCard from '../../../subscreens/users/blogs/blogcard/BlogCard';

const Blogs = () => {
  return (
    <>
      <MyNavbar />
      <BlogBanner />
      <BlogCard/>
      <Footer />
    </>
  );

}

export default Blogs;